import React from 'react';
import * as S from './SplashPage.styled';
import { Link as ReactRouterLink } from 'react-router-dom';
import {
  MCX_CALCULATOR,
  SWITCHER_CALC,
  APPOINTMENT_BOOKING,
  DIGITAL_MORTGAGE_UNPROTECTED,
  DASHBOARD,
} from './../../../lib/urls';

const DebugLinks = () => {
  const openTestTools = () =>
    window.open('http://localhost:5173', 'test_tools');

  return (
    <>
      <S.DebugLinksSwitch type="checkbox" id="dev-tools-cb" />
      <S.DebugLinksWrapper>
        <S.DebugLinksLabel htmlFor="dev-tools-cb">
          Dev Tools <S.DebugLinksChevron />
        </S.DebugLinksLabel>
        <h3>Other apps</h3>
        <ul>
          <li>
            <ReactRouterLink to={DIGITAL_MORTGAGE_UNPROTECTED}>
              Digital Mortgage
            </ReactRouterLink>
          </li>
          <li>
            <ReactRouterLink to={SWITCHER_CALC}>Switcher</ReactRouterLink>
          </li>
          <li>
            <ReactRouterLink to={MCX_CALCULATOR}>Calculator</ReactRouterLink>
          </li>
          <li>
            <ReactRouterLink to={APPOINTMENT_BOOKING + '-new'}>
              Appointment Booking (new)
            </ReactRouterLink>
          </li>
          <li>
            <ReactRouterLink to={APPOINTMENT_BOOKING + '-change'}>
              Appointment Booking (change)
            </ReactRouterLink>
          </li>
          <li>
            <ReactRouterLink to={DASHBOARD}>Dashboard</ReactRouterLink>
          </li>
        </ul>
        <button onClick={openTestTools}>Open Test Tools</button>
      </S.DebugLinksWrapper>
    </>
  );
};

export default DebugLinks;
